import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "audio-editor-molecule" }
const _hoisted_2 = { class: "cover-img" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "cover-audio" }
const _hoisted_5 = {
  key: 1,
  class: "my-audio"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "audio-controls" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "tags" }
const _hoisted_11 = { class: "premium-checkbox" }
const _hoisted_12 = { class: "checkbox-label" }
const _hoisted_13 = { class: "collection" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "name-and-img" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "caption" }

import {
    ref,
    watch,
    onMounted,
    onUnmounted,
    computed,
  } from 'vue';
  import IconAtom from '@/components/atoms/IconAtom.vue';
  import ButtonAtom from '@/components/atoms/ButtonAtom.vue';
  import InputAtom from '@/components/atoms/InputAtom.vue';
  import InputSelectAtom from '@/components/atoms/InputSelectAtom.vue';
  import AddNewTagAtom from '@/components/atoms/AddNewTagAtom.vue';
  import AddToCollectionAtom from '@/components/atoms/AddToCollectionAtom.vue';
  import {
    SelectOption,
    transformToSelectOptions,
  } from '@/shared/selectOption';
  import tagService from '@/services/tag/tag.service';
  import Collection from '@/models/collection/collection.model';
  import collectionService from '@/services/collection/collection.service';
  import { useStore } from 'vuex';

  const actionCollectionsGetter = 'resource/getResourceCollections';
  const actionCollectionSet = 'resource/addCollection';
  const actionCollectionRemove = 'resource/removeCollection';
  const actionTagGetter = 'resource/getResourceTags';
  const actionTagSet = 'resource/addTag';
  const actionTagRemove = 'resource/removeTag';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AudioEditorMolecule',
  props: {
    resourceDetails: {}
  },
  emits: ['updateResourceDetails', 'updatePreview'],
  setup(__props: any, { emit: __emit }) {

  const props = __props;
  const emit = __emit;
  const store = useStore();

  const localResourceDetails = ref({ 
    ...props.resourceDetails
  });
  const showAddNewTagModal = ref(false);
  const showAddToCollectionModal = ref(false);
  const coverImage = ref<string | null>(null);
  const audioFile = ref<string | null>(null);
  const uploadedImg = ref<HTMLInputElement | null>(null);
  const uploadedAudio = ref<HTMLInputElement | null>(null);
  const tagOptions = ref<SelectOption[]>([]);
  const collectionOptions = ref<Collection[]>([]);

  const audioPlayer = ref<HTMLAudioElement | null>(null);
  const playPauseBtn = ref<HTMLInputElement | null>(null);
  const audioPlayIcon = ref<HTMLInputElement | null>(null);
  const audioPauseIcon = ref<HTMLInputElement | null>(null);
  const progressBar = ref<HTMLInputElement | null>(null);
  const audioVolumeControl = ref<HTMLInputElement | null>(null);
  const audioMuteToggle = ref<HTMLInputElement | null>(null);
  const timeDisplay = ref<HTMLInputElement | null>(null);

  const selectedCollections = computed(
    () => store.getters[actionCollectionsGetter] || [],
  );

  onMounted(() => {
    fetchTags();
    fetchCollections();
  });

  watch(
    () => props.resourceDetails,
    (newValue) => {
      localResourceDetails.value = { ...newValue };
      coverImage.value = localResourceDetails.value.banner;
      audioFile.value = localResourceDetails.value.url_path;
    },
    { immediate: true, deep: true },
  );

  watch(
    localResourceDetails,
    () => {
      updateResourceDetails();
    },
    { deep: true },
  );

  const fetchTags = async () => {
    tagOptions.value = transformToSelectOptions(
      ((await tagService.getAllNoFilter()) as any).data,
      'tag_id',
      'tag_name',
    );
  };

  const fetchCollections = async () => {
    collectionOptions.value = (
      (await collectionService.getAllNoFilter()) as any
    ).data;
  };

  function handleNewTagAdded(newTag: string) {
    fetchTags();
    showAddNewTagModal.value = false;
  }

  function openAddNewTagModal() {
    showAddNewTagModal.value = true;
  }

  function openAddToCollectionModal() {
    showAddToCollectionModal.value = true;
  }

  function triggerImgUpload() {
    uploadedImg.value?.click();
  }

  function triggerAudioUpload() {
    uploadedAudio.value?.click();
  }

  function imgupload(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      coverImage.value = e.target?.result as string;
      updateResourceDetails();
    };
    reader.readAsDataURL(file);
    localResourceDetails.value.banner = file;
  }

  function audioChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      audioFile.value = e.target?.result as string;
      updateResourceDetails();
    };
    reader.readAsDataURL(file);
    localResourceDetails.value.url_path = file;
  }

  function clearImage() {
    coverImage.value = null;
    if (uploadedImg.value) {
      uploadedImg.value.value = '';
      localResourceDetails.value.banner = '';
    }
    updateResourceDetails();
  }

  function clearAudioFile() {
    if (uploadedAudio.value) {
      uploadedAudio.value.value = '';
      localResourceDetails.value.url_path = '';
    }
    audioFile.value = null;
    updateResourceDetails();
  }

  function updateResourceDetails() {
    emit('updateResourceDetails', localResourceDetails);
    setAudioFileUrl();
  }

  function handleCollectionsUpdate(collections: string[]) {
    localResourceDetails.value.collections = collections;
    showAddToCollectionModal.value = false;
  }

  function handleCollectionRemove(collection: string) {
    store.dispatch(actionCollectionRemove, collection);
    localResourceDetails.value.collections = selectedCollections.value;

    if (selectedCollections.value.length === 0) {
      showAddToCollectionModal.value = false;
    }

    updateResourceDetails();
  }

  function setAudioFileUrl() {
    if (!localResourceDetails.value.url_path) {
      return null;
    }
    if (typeof localResourceDetails.value.url_path == 'object') {
      const fileURL = URL.createObjectURL(localResourceDetails.value.url_path);
      audioFile.value = fileURL;
    }
  }

  function addTagToSelection(newTag) {
    if (!localResourceDetails.value.tags) {
      localResourceDetails.value.tags = [];
    }

    if (localResourceDetails.value.tags.length < 3) {
      localResourceDetails.value.tags.push({
        id: newTag.tag_id,
        value: newTag.tag_name,
      });

      store.dispatch(actionTagSet, {
        id: newTag.tag_id,
        value: newTag.tag_name,
      });
    }
  }

  updateResourceDetails();

  const isPaused = ref(true);
  const isMuted = ref(false);
  const currentTime = ref(0);
  const duration = ref(0);
  const progress = ref(0);

  onMounted(() => {
    if (audioPlayer.value) {
      audioPlayer.value.controls = false;
      playPauseBtn.value?.addEventListener('click', togglePlayPause);
      audioPlayer.value?.addEventListener('loadedmetadata', updateDuration);
      audioPlayer.value?.addEventListener('timeupdate', updateTime);
      progressBar.value?.addEventListener('input', updateProgress);
      audioVolumeControl.value?.addEventListener('input', updateVolume);
      audioMuteToggle.value?.addEventListener('click', toggleMute);
      audioPlayer.value?.addEventListener('ended', resetPlayer);
      audioVolumeControl.value?.addEventListener('input', updateVolume);
    }
  });

  onUnmounted(() => {
    if (audioPlayer.value) {
      playPauseBtn.value?.removeEventListener('click', togglePlayPause);
      audioPlayer.value?.removeEventListener('loadedmetadata', updateDuration);
      audioPlayer.value?.removeEventListener('timeupdate', updateTime);
      progressBar.value?.removeEventListener('input', updateProgress);
      audioVolumeControl.value?.removeEventListener('input', updateVolume);
      audioMuteToggle.value?.removeEventListener('click', toggleMute);
      audioPlayer.value?.removeEventListener('ended', resetPlayer);
      audioVolumeControl.value?.removeEventListener('input', updateVolume);
    }
  });

  function togglePlayPause() {
    if (audioPlayer.value?.paused || audioPlayer.value?.ended) {
      audioPlayer.value?.play();
      isPaused.value = false;
    } else {
      audioPlayer.value?.pause();
      isPaused.value = true;
    }
    updatePlayPauseIcons();
  }

  function updatePlayPauseIcons() {
    if (isPaused.value) {
      audioPlayIcon.value?.style.setProperty('display', 'inline');
      audioPauseIcon.value?.style.setProperty('display', 'none');
    } else {
      audioPlayIcon.value?.style.setProperty('display', 'none');
      audioPauseIcon.value?.style.setProperty('display', 'inline');
    }
  }

  function updateDuration() {
    duration.value = audioPlayer.value?.duration || 0;
    timeDisplay.value!.textContent = `00:00 / ${formatTime(duration.value)}`;
  }

  function updateTime() {
    if (audioPlayer.value) {
      currentTime.value = audioPlayer.value.currentTime;
      progress.value =
        (audioPlayer.value.currentTime / audioPlayer.value.duration) * 100;
      timeDisplay.value!.textContent = `${formatTime(
        currentTime.value,
      )} / ${formatTime(duration.value)}`;
      progressBar.value!.value = progress.value.toString();
      progressBar.value?.style.setProperty(
        '--progress-percent',
        `${progress.value}%`,
      );
    }
  }

  function updateProgress() {
    if (audioPlayer.value && progressBar.value) {
      audioPlayer.value.currentTime =
        (parseFloat(progressBar.value.value) / 100) *
        audioPlayer.value.duration;
    }
  }

  const updateVolume = () => {
    if (audioPlayer.value && audioVolumeControl.value) {
      audioPlayer.value.volume =
        parseFloat(audioVolumeControl.value.value) / 100;
      audioVolumeControl.value.style.setProperty(
        '--volume-percent',
        `${audioVolumeControl.value.value}%`,
      );
      isMuted.value = audioPlayer.value.volume === 0;
      updateMuteIcons();
    }
  };

  function toggleMute() {
    if (audioPlayer.value) {
      audioPlayer.value.muted = !audioPlayer.value.muted;
      isMuted.value = audioPlayer.value.muted;
      updateMuteIcons();
    }
  }

  function updateMuteIcons() {
    const volumeIcon = document.getElementById('audio-volume-icon');
    const muteIcon = document.getElementById('audio-mute-icon');
    if (isMuted.value) {
      volumeIcon!.style.display = 'none';
      muteIcon!.style.display = 'inline';
    } else {
      volumeIcon!.style.display = 'inline';
      muteIcon!.style.display = 'none';
    }
  }

  function resetPlayer() {
    isPaused.value = true;
    audioPlayer.value!.currentTime = 0;
    timeDisplay.value!.textContent = `00:00 / ${formatTime(duration.value)}`;
    updatePlayPauseIcons();
  }

  function formatTime(time: number) {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, '0');
    const seconds = Math.floor(time % 60).toString();
    return `${minutes}:${seconds}`;
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "editor-title" }, "Add new audio details", -1)),
      _createVNode(ButtonAtom, {
        class: "btn btn-secondary coverBtn",
        style: _normalizeStyle({
          backgroundImage: coverImage.value ? `url(${coverImage.value})` : '',
          border: coverImage.value ? 'none' : '1.5px dashed #ccc',
        }),
        onClick: triggerImgUpload
      }, {
        default: _withCtx(() => [
          (!coverImage.value)
            ? (_openBlock(), _createBlock(IconAtom, {
                key: 0,
                icon: "cameraIcon"
              }))
            : _createCommentVNode("", true),
          (!coverImage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Cover"))
            : _createCommentVNode("", true),
          (coverImage.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "clear-image-btn",
                onClick: _withModifiers(clearImage, ["stop"])
              }, " X "))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["style"]),
      _createElementVNode("input", {
        type: "file",
        ref_key: "uploadedImg",
        ref: uploadedImg,
        accept: "image/*",
        onChange: imgupload,
        style: {"display":"none"}
      }, null, 544)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[10] || (_cache[10] = _createElementVNode("label", { for: "title" }, "Media", -1)),
      (!audioFile.value)
        ? (_openBlock(), _createBlock(ButtonAtom, {
            key: 0,
            class: "btn btn-secondary audioCoverButton",
            style: {},
            onClick: triggerAudioUpload
          }, {
            default: _withCtx(() => [
              _createVNode(IconAtom, { icon: "audioIcon" }),
              _cache[6] || (_cache[6] = _createElementVNode("p", null, "Select an audio file", -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (audioFile.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("audio", {
              ref_key: "audioPlayer",
              ref: audioPlayer
            }, [
              _createElementVNode("source", {
                src: audioFile.value,
                type: "audio/mpeg"
              }, null, 8, _hoisted_6),
              _createElementVNode("source", {
                src: audioFile.value,
                type: "audio/ogg"
              }, null, 8, _hoisted_7),
              _cache[7] || (_cache[7] = _createTextVNode(" Your browser does not support the audio element. "))
            ], 512),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                ref_key: "playPauseBtn",
                ref: playPauseBtn,
                id: "audio-play-pause"
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  ref_key: "audioPlayIcon",
                  ref: audioPlayIcon,
                  id: "audio-play-icon",
                  viewBox: "0 0 24 24"
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("path", { d: "M8 5v14l11-7z" }, null, -1)
                ]), 512)),
                (_openBlock(), _createElementBlock("svg", {
                  ref_key: "audioPauseIcon",
                  ref: audioPauseIcon,
                  id: "audio-pause-icon",
                  viewBox: "0 0 24 24",
                  style: {"display":"none"}
                }, _cache[9] || (_cache[9] = [
                  _createElementVNode("path", { d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z" }, null, -1)
                ]), 512))
              ], 512),
              _createElementVNode("span", {
                ref_key: "timeDisplay",
                ref: timeDisplay,
                id: "time-display"
              }, "00:00 / 00:00", 512),
              _createElementVNode("input", {
                type: "range",
                ref_key: "progressBar",
                ref: progressBar,
                id: "audio-progress",
                value: "0",
                max: "100"
              }, null, 512),
              _createElementVNode("button", {
                ref_key: "audioMuteToggle",
                ref: audioMuteToggle,
                id: "audio-mute-toggle"
              }, [
                _createVNode(IconAtom, {
                  icon: "volumeIcon",
                  id: "audio-volume-icon",
                  color: "black"
                }),
                _createVNode(IconAtom, {
                  icon: "muteIcon",
                  id: "audio-mute-icon",
                  color: "black"
                })
              ], 512),
              _createElementVNode("input", {
                type: "range",
                ref_key: "audioVolumeControl",
                ref: audioVolumeControl,
                id: "audio-volume-control",
                value: "100",
                max: "100"
              }, null, 512),
              (audioFile.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "clear-audio-button",
                    onClick: _withModifiers(clearAudioFile, ["stop"])
                  }, " X "))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        type: "file",
        ref_key: "uploadedAudio",
        ref: uploadedAudio,
        accept: "audio/*",
        onChange: audioChange,
        style: {"display":"none"}
      }, null, 544)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[11] || (_cache[11] = _createElementVNode("label", { for: "title" }, "Title", -1)),
      _createVNode(InputAtom, {
        id: "title",
        modelValue: localResourceDetails.value.resource_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localResourceDetails.value.resource_name) = $event)),
        placeholder: "Name",
        class: "input"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[12] || (_cache[12] = _createElementVNode("label", { for: "tags" }, "Tags (maximum 3)", -1)),
      _createVNode(InputSelectAtom, {
        id: "tags",
        placeholder: "Add tags",
        modelValue: localResourceDetails.value.tags,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localResourceDetails.value.tags) = $event)),
        options: tagOptions.value,
        onAddNew: openAddNewTagModal,
        tagsGetter: actionTagGetter,
        tagSet: actionTagSet,
        tagRemove: actionTagRemove
      }, null, 8, ["modelValue", "options"]),
      _createVNode(AddNewTagAtom, {
        show: showAddNewTagModal.value,
        "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (showAddNewTagModal.value = $event)),
        onNewTagAdded: handleNewTagAdded,
        onAddTagToSelection: addTagToSelection
      }, null, 8, ["show"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "checkbox-input",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localResourceDetails.value.is_premium) = $event))
        }, null, 512), [
          [_vModelCheckbox, localResourceDetails.value.is_premium]
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "custom-checkbox" }, null, -1)),
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "checkbox-label-text" }, "Premium", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[16] || (_cache[16] = _createElementVNode("label", { for: "collection" }, "Collection", -1)),
      (selectedCollections.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCollections.value, (collection) => {
              return (_openBlock(), _createElementBlock("div", {
                key: collection,
                class: "collection-item"
              }, [
                _createElementVNode("div", _hoisted_15, [
                  (collection.banner)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: collection.banner,
                        alt: "Collection Image",
                        class: "collection-icon"
                      }, null, 8, _hoisted_16))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(collection.collection_name), 1)
                ]),
                _createVNode(IconAtom, {
                  icon: "deleteIcon",
                  onClick: () => handleCollectionRemove(collection),
                  class: "pointer"
                }, null, 8, ["onClick"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(ButtonAtom, {
        class: "btn btn-secondary collectionBtn",
        onClick: openAddToCollectionModal
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [
          _createTextVNode(" + Add to a collection ")
        ])),
        _: 1
      }),
      _createVNode(AddToCollectionAtom, {
        show: showAddToCollectionModal.value,
        collections: collectionOptions.value,
        "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (showAddToCollectionModal.value = $event)),
        onUpdateCollections: handleCollectionsUpdate,
        actionCollectionsGetter: actionCollectionsGetter,
        actionCollectionSet: actionCollectionSet,
        actionCollectionRemove: actionCollectionRemove
      }, null, 8, ["show", "collections"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _cache[17] || (_cache[17] = _createElementVNode("label", { for: "caption" }, "Captions", -1)),
      _createVNode(InputAtom, {
        id: "caption",
        placeholder: "Captions are auto-generated",
        class: "input"
      })
    ])
  ]))
}
}

})